export default "__VITE_ASSET__BcqWC5KV__"